<template>
    <el-config-provider :locale="zhCn" v-if="data.isLoadOver">
        <router-view class="routeview"></router-view>
    </el-config-provider>
</template>
<script setup>
    import { onMounted, reactive } from "vue";
    import { GetUrlParam, SaasApi } from "qk-lib-v3";
    import { RouterView } from "vue-router";
    import zhCn from "element-plus/dist/locale/zh-cn.mjs";

    import { ElConfigProvider } from "element-plus";

    const data = reactive({
        isLoadOver: false,
    })

    const setTopTheme = (theme) => {
        switch (theme) {
            case "blue":
                {
                    document.body.style.setProperty("--saas-top-bg-img", "linear-gradient(to right, #0baffe, #7941d4)");
                    document.body.style.setProperty("--saas-top-text-color", "#ffffff");
                    document.body.style.setProperty("--saas-top-active-text-color", "#e2e2e2");
                }
                break;
            case "white":
                {
                    document.body.style.setProperty("--saas-top-bg-img", "linear-gradient(to right, #ffffff, #ffffff)");
                    document.body.style.setProperty("--saas-top-text-color", "#000000");
                    document.body.style.setProperty("--saas-top-active-text-color", "#9f9f9f");
                }
                break;
            case "lightBlue":
                {
                    document.body.style.setProperty("--saas-top-bg-img", "linear-gradient(to right, #32A3BC, #49CBB9)");
                    document.body.style.setProperty("--saas-top-text-color", "#ffffff");
                    document.body.style.setProperty("--saas-top-active-text-color", "#e2e2e2");
                }
                break;
        }
    }
    const setLeftTheme = (theme) => {
        switch (theme) {
            case "lightBlue":
                {
                    document.body.style.setProperty("--saas-left-bg-img", "linear-gradient(to bottom, #34bac0, #66b952)");
                    document.body.style.setProperty("--saas-left-text-color", "#fdfdfd");
                    document.body.style.setProperty("--saas-left-active-text-color", "#5af9e7");

                    document.body.style.setProperty("--el-menu-text-color", "#232323");
                    document.body.style.setProperty("--el-menu-bg-color", "rgba(0,0,0,0)"); //菜单背景颜色
                    document.body.style.setProperty("--el-menu-hover-bg-color", "rgba(226, 234, 234, 0.5)"); //鼠标移动到菜单上时的 字体颜色
                }
                break;
            case "white":
                {
                    document.body.style.setProperty("--el-menu-text-color", "#000000");
                    document.body.style.setProperty("--el-menu-bg-color", "rgba(0,0,0,0)"); //菜单背景颜色
                    document.body.style.setProperty("--el-menu-hover-bg-color", "rgba(223, 223, 223, 0.5)"); //鼠标移动到菜单上时的 字体颜色

                    document.body.style.setProperty("--saas-left-bg-img", "linear-gradient(to bottom, #ffffff, #ffffff)");
                    document.body.style.setProperty("--saas-left-text-color", "#060606");
                    document.body.style.setProperty("--saas-left-active-text-color", "#8a8a8a");
                }
                break;
            case "blue":
                {
                    //document.body.style.setProperty("--saas-left-bg-img", "linear-gradient(to bottom, #32A3BC, #49CBB9)");
                    document.body.style.setProperty("--saas-left-bg-img", "linear-gradient(to bottom, #7941d4, #0baffe)");
                    document.body.style.setProperty("--saas-left-text-color", "#fdfdfd");
                    document.body.style.setProperty("--saas-left-active-text-color", "#5af9e7");

                    document.body.style.setProperty("--el-menu-text-color", "#232323");
                    document.body.style.setProperty("--el-menu-bg-color", "rgba(0,0,0,0)"); //菜单背景颜色
                    document.body.style.setProperty("--el-menu-hover-bg-color", "rgba(226, 234, 234, 0.5)"); //鼠标移动到菜单上时的 字体颜色
                }
                break;
        }
    }

    const setOrganSelectTheme = (theme) => {
        switch (theme) {
            case "blue":
                {
                    document.body.style.setProperty("--saas-system-background-image", "linear-gradient(to right, #0baffe, #7743d5)");
                    document.body.style.setProperty("--saas-systemitem-background-color", "rgba(210, 186, 243, 0.3)");
                    document.body.style.setProperty("--saas-systemitem-color", "white");
                    document.body.style.setProperty("--saas-systemitem-hover-background-color", "rgba(222, 226, 227, 0.6)");
                }
                break;
            case "lightBlue":
                {
                    document.body.style.setProperty("--saas-system-background-image", "linear-gradient(to bottom,#32A3BC, #49CBB9 )");
                    document.body.style.setProperty("--saas-systemitem-background-color", "#FDFDFD");
                    document.body.style.setProperty("--saas-systemitem-color", "#2DB9B6");
                    document.body.style.setProperty("--saas-systemitem-hover-background-color", "rgba(222, 226, 227, 1)");
                }
                break;
        }
    }
    const onUpdateTheme = () => {
        /**
                 * 	
                 * 上蓝左白: "0",
                 * 上白左蓝: "1",
                 * 上白左绿: "2",
                 * 上绿左白: "3"
                 */
        switch (sessionStorage.getItem("Theme")) {
            case "blue":
                setTopTheme("white");
                setLeftTheme("blue");
                setOrganSelectTheme("blue");
                break;
            case "lightBlue":
                setTopTheme("white");
                setLeftTheme("blue");
                setOrganSelectTheme("lightBlue");
                break;
            case "0"://上蓝左白
                setTopTheme("blue");
                setLeftTheme("white");
                setOrganSelectTheme("blue");
                break;
            case "1"://上白左蓝
                setTopTheme("white");
                setLeftTheme("blue");
                setOrganSelectTheme("blue");
                break;
            case "2"://上白左绿
                setTopTheme("white");
                setLeftTheme("lightBlue");
                setOrganSelectTheme("lightBlue");
                break;
            case "3"://上绿左白
                setTopTheme("lightBlue");
                setLeftTheme("white");
                setOrganSelectTheme("lightBlue");
                break;
            default: {
                setTopTheme("blue");
                setLeftTheme("white");
                setOrganSelectTheme("blue");
                break;
            }
        }
    }

    onMounted(async () => {
        onUpdateTheme();
        window.onUpdateTheme = onUpdateTheme;
        let urlToken = GetUrlParam("Token");
        if (urlToken) {
            let token = sessionStorage.getItem("Token");
            if (urlToken != token) {
                console.log("路由跳转，获取到UrlToken", urlToken);
                sessionStorage.setItem("Token", urlToken);
                token = urlToken;
                let managerInfo = await SaasApi("/Api/GetMyDocument");
                sessionStorage.setItem("ManagerInfo", JSON.stringify(managerInfo));
            } else
                console.log("路由跳转，UrlToken与SessionToken一致，无需更新", urlToken);
        }
        data.isLoadOver = true;
    });
</script>
<style>
    .el-menu--popup .el-menu-item {
        color: var(--saas-menu-popup-text-color) !important;
    }
</style>
<style scoped>
    .routeview {
        width: 100%;
        height: 100%;
    }
</style>
